<template>
  <g class="dots">
    <circle
      :class="[
        'dot',
        {
          selected:
            p.tooltipMove &&
            p.tooltipMove.datum &&
            p.tooltipMove.datum[c.xAxis] == datum[c.xAxis],
        },
      ]"
      v-for="(datum, index) in d"
      :key="'circle-' + index"
      :cx="p.scaleX(datum[c.xAxis])"
      :cy="p.scaleY(datum[serie.key])"
      :r="serie.dotSize"
      :style="{ fill: serie.dotColor }"
    />
    <text
      :class="[
        'label',
        {
          selected:
            p.tooltipMove &&
            p.tooltipMove.datum &&
            p.tooltipMove.datum[c.xAxis] == datum[c.xAxis],
          hidden: checkTextVisibility(d, datum, index) || index % 2,
        },
      ]"
      v-for="(datum, index) in d"
      :key="index"
      :x="p.scaleX(datum[c.xAxis])"
      :y="p.scaleY(datum[serie.key])"
      :dy="-18"
      :dx="index === d.length - 1 ? -10 : index === 0 ? 10 : 0"
      :fontSize="serie.fontSize"
      :style="{ fontSize: serie.fontSize }"
    >
      {{ p.format(datum[serie.key]) }}{{ c.globalUnitSymbol }}
    </text>
  </g>
</template>

<script>
export default {
  props: ["p", "c", "d", "serie"],
  methods: {
    checkTextVisibility(d, datum, index) {
      // Show only when year gap is more than max gap

      const findMaxAxisGap = () => {
        let max = 0;

        d.forEach((o, i) => {
          if (d[i + 1] && d[i + 1][this.c.xAxis] - o[this.c.xAxis] > max) {
            max = d[i + 1][this.c.xAxis] - o[this.c.xAxis];
          }
        });

        return max;
      };
      const maxAxisGap = findMaxAxisGap();
      return (
        d[index + 1] &&
        d[index + 1][this.c.xAxis] - datum[this.c.xAxis] < maxAxisGap
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.dots {
  .dot {
    &.selected {
    }
  }
  .label {
    fill: $primary-yellow;
    @include number-S;
    text-anchor: middle;
    &.hidden {
      display: none;
    }
    &.selected {
      display: block;
    }
  }
}
</style>